module.exports = __webpack_public_path__ + "c4af9c70e47864e68f0f126c1e0e634b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/felipe-ribeiro.jpg
 ** module id = 410
 ** module chunks = 0
 **/